module.exports = __webpack_public_path__ + "img/img_product_app.4aaec29f.png";